import React, { useEffect, useState } from 'react';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { Modal } from '../Modals/Modal';
import useStyle from './classNgoChoice.style';
import useGoToPage from 'hooks/useGoToPage';
import pages from 'routes/pages';
import { useQuery } from '@apollo/client';
import { GetClasseWithNoteAndStudentsOrdersQuery } from 'graphql/generated/graphql';
import { QUERY_CLASSE_WITH_NOTE_AND_STUDENTS_ORDERS } from 'graphql/query/classe/queryClasseWithNoteAndStudentsOrders';
import { IS_PROF, MY_ID } from 'helpers/user/authorization';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from '../Error/ErrorContainer';
import { getNgoInformationsFromQuery } from 'helpers/transformApiResponse/ong';

const ClassNgoChoice = () => {
  const style = useStyle();
  const [closedModals, setClosedModals] = useState<number[]>([]);

  useEffect(() => {
    // Charger les modales fermées depuis localStorage au montage
    const storedClosedModals = localStorage.getItem('closedModals');
    if (storedClosedModals) {
      setClosedModals(JSON.parse(storedClosedModals));
    }
  }, []);

  const handleCloseModal = (modalId: number) => {
    const updatedClosedModals = [...closedModals, modalId];
    setClosedModals(updatedClosedModals);
    localStorage.setItem('closedModals', JSON.stringify(updatedClosedModals));
  };

  const toNgoClassChoice = useGoToPage(pages.NGO_CHOICE_PAGE.path, {
    type: 'classe'
  });
  const { data, loading, error } = useQuery<
    GetClasseWithNoteAndStudentsOrdersQuery
  >(QUERY_CLASSE_WITH_NOTE_AND_STUDENTS_ORDERS, {
    variables: {
      userId: MY_ID
    }
  });

  if (loading) return <LoadingContainer status={loading} />;
  if (error) return <ErrorContainer />;
  const { studentsClass } = getNgoInformationsFromQuery(data);

  const MODALS = [
    {
      id: 1,
      startDate: '2025-03-10', // 2025-03-10 J exact
      endDate: '2025-03-17', // 2025-03-17 J+1
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Engagez-vous dans une action solidaire !
          </h1>
          <p>
            Nous vous offrons l’occasion de sensibiliser vos élèves aux valeurs
            de solidarité et d’engagement. Dès maintenant, vous pouvez, avec
            votre classe, décider de reverser ou pas une partie de votre
            commission à une ONG. Ce choix collectif est une belle façon de
            montrer l'importance d’agir ensemble pour un monde plus solidaire.
            Et peut devenir un véritable levier de motivation pour vos élèves !
          </p>
          <p>
            Vous avez jusqu'au <span className={style.date}>30/03/2025</span>{' '}
            pour décider. Si aucun choix n'est fait, 5% seront automatiquement
            reversés aux 3 ONG.
          </p>
        </div>
      )
    },
    {
      id: 2,
      startDate: '2025-03-17', //2025-03-17
      endDate: '2025-03-24', //2025-03-24
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Plus que quelques jours pour faire votre choix ONG !
          </h1>
          <p>
            Vous avez toujours la possibilité de reverser ou pas une partie de
            votre commission à une ONG, afin de soutenir une cause et
            sensibiliser vos élèves à l'engagement solidaire.
          </p>
          <p>
            Ne laissez pas passer cette occasion d’échanger avec vos élèves
            autour d’un thème “citoyen” et de développer la motivation
            collective de “bien faire” !
          </p>
          <p>
            La date limite approche ! Si vous ne faîtes pas de choix avant le{' '}
            <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
        </div>
      )
    },
    {
      id: 3,
      startDate: '2025-03-24', //2025-03-24
      endDate: '2025-03-26', //2025-03-31
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Dernière chance pour faire votre choix ONG !
          </h1>
          <p>C'est la dernière semaine pour choisir une ONG à soutenir.</p>
          <p>
            Votre engagement compte et inspire vos élèves ! Il est encore temps
            d'agir et de mobiliser le collectif autour d'une belle cause !
          </p>
          <p>
            Après le <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
          <p>Prenez un instant pour choisir maintenant !</p>
        </div>
      )
    },
    {
      id: 4,
      startDate: '2025-03-26', //2025-03-24
      endDate: '2025-03-27', //2025-03-31
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Dernière chance pour faire votre choix ONG !
          </h1>
          <p>C'est la dernière semaine pour choisir une ONG à soutenir.</p>
          <p>
            Votre engagement compte et inspire vos élèves ! Il est encore temps
            d'agir et de mobilier le collectif autour d'une belle cause !
          </p>
          <p>
            Après le <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
          <p>Prenez un instant pour choisir maintenant !</p>
        </div>
      )
    },
    {
      id: 5,
      startDate: '2025-03-27', //2025-03-24
      endDate: '2025-03-28', //2025-03-31
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Dernière chance pour faire votre choix ONG !
          </h1>
          <p>C'est la dernière semaine pour choisir une ONG à soutenir.</p>
          <p>
            Votre engagement compte et inspire vos élèves ! Il est encore temps
            d'agir et de mobiliser le collectif autour d'une belle cause !
          </p>
          <p>
            Après le <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
          <p>Prenez un instant pour choisir maintenant !</p>
        </div>
      )
    },
    {
      id: 6,
      startDate: '2025-03-28', //2025-03-24
      endDate: '2025-03-29', //2025-03-31
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Dernière chance pour faire votre choix ONG !
          </h1>
          <p>C'est la dernière semaine pour choisir une ONG à soutenir.</p>
          <p>
            Votre engagement compte et inspire vos élèves ! Il est encore temps
            d'agir et de mobiliser le collectif autour d'une belle cause !
          </p>
          <p>
            Après le <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
          <p>Prenez un instant pour choisir maintenant !</p>
        </div>
      )
    },
    {
      id: 7,
      startDate: '2025-03-29', //2025-03-24
      endDate: '2025-03-30', //2025-03-31
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Dernière chance pour faire votre choix ONG !
          </h1>
          <p>C'est la dernière semaine pour choisir une ONG à soutenir.</p>
          <p>
            Votre engagement compte et inspire vos élèves ! Il est encore temps
            d'agir et de mobiliser le collectif autour d'une belle cause !
          </p>
          <p>
            Après le <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
          <p>Prenez un instant pour choisir maintenant !</p>
        </div>
      )
    },
    {
      id: 8,
      startDate: '2025-03-30', //2025-03-24
      endDate: '2025-03-31', //2025-03-31
      content: (
        <div className={style.modalContent}>
          <h1 className={style.headerText}>
            Dernière chance pour faire votre choix ONG !
          </h1>
          <p>C'est la dernière semaine pour choisir une ONG à soutenir.</p>
          <p>
            Votre engagement compte et inspire vos élèves ! Il est encore temps
            d'agir et de mobiliser le collectif autour d'une belle cause !
          </p>
          <p>
            Après le <span className={style.date}>30/03/2025</span>, 5% seront
            automatiquement reversés aux 3 ONG.
          </p>
          <p>Prenez un instant pour choisir maintenant !</p>
        </div>
      )
    }
  ];
  const today = new Date();
  const selectedModal = MODALS.find(
    modal =>
      new Date(modal.startDate) <= today &&
      new Date(modal.endDate) >= today &&
      !closedModals.includes(modal.id)
  );
  if (!IS_PROF || !selectedModal || studentsClass.ngo) return null;
  return (
    <Modal
      modalHead="Choix de l'ONG de la classe"
      isShowingDefault={true}
      actionButton={
        <ButtonWithText
          onClick={toNgoClassChoice}
          content="Je choisis l'ONG de la classe"
        />
      }
      onCloseAction={() => handleCloseModal(selectedModal.id)}
    >
      {selectedModal.content}
    </Modal>
  );
};

export default ClassNgoChoice;
